import { CLOSE_EDIT_WINDOW, OPEN_EDIT_WINDOW } from '../action-types';

const initState = {
  isVisible: false,
  leadId: null,
};

const EditStatusDrawer = (state = initState, action) => {
  const { payload } = action;
  switch (action.type) {
    case OPEN_EDIT_WINDOW:
      return {
        ...state,
        leadId: payload.leadId,
        isVisible: true,
      };

    case CLOSE_EDIT_WINDOW:
      return {
        ...state,
        leadId: null,
        isVisible: false,
      };

    default:
      return state;
  }
};

export default EditStatusDrawer;
